<template>
  <div class="col-empty">
    <div class="empty-icon">
      <i class="el-icon-document" style="font-size: 18px;"></i>
    </div>
    <p class="empty-title">Sin notas de crédito</p>
    <p class="empty-sub">No hay documentos<br />en este período</p>
    <button
      v-if="$canOpen('sales.creditNote.add')"
      class="empty-cta"
      @click="onAdd"
    >
      <svg width="10" height="10" viewBox="0 0 14 14" fill="none">
        <path
          d="M7 1v12M1 7h12"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
      Crear nueva
    </button>
  </div>
</template>

<script>
export default {
  name: "CreditNoteEmptyComponent",
  methods: {
    onAdd() {
      this.$router.push({ name: "sales.creditNote.add" });
    }
  }
};
</script>
